import { render, staticRenderFns } from "./AddonsListItem.vue?vue&type=template&id=520a869c&scoped=true&"
import script from "./AddonsListItem.vue?vue&type=script&lang=js&"
export * from "./AddonsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a869c",
  null
  
)

export default component.exports